import ProctorProfile from "../components/proctor/components/proctor-profile";
import SectionTitle from "../components/shared/sectionTitle/sectionTitle";
import { getImage } from "../services/image-utils";

export default function ProctorRoute() {
  const logo = getImage("/assets/SEABC_Logo.png");
  return (
    <>
      <SectionTitle>
        <img src={logo} alt="SEABC logo" className="max-h-14 mr-3.5" />
        <h1 className="text-3xl m-0 font-normal">Proctor Profile</h1>
      </SectionTitle>
      <ProctorProfile />
    </>
  );
}
